$(document).ready(function(){
	if( typeof avgDownloadLink !== 'undefined') {
		setTimeout(
			function(){
				window.location = encodeURI( avgDownloadLink );
			}
			,1000
		);
	}
});
